import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { Auth } from "aws-amplify";
import DocumentSync from "../../src/Component/Images/DS2Logo.jpg";
import { saveAuditTrail } from "../libs/API";
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    // console.log("header props", props);
  }

  clearTokens = () => {
    this.props.props.hasAuthenticated = false;
    this.props.props.loggedInUser = "";
    this.props.props.hasManageMetadataTemplate = false;
    this.props.props.hasManageRepositories = false;
    this.props.props.hasEditIndex = false;
    this.props.props.hasManageRedaction = false;
    this.props.props.hasManageUsers = false;
    this.props.props.hasManageFiles = false;
    this.props.props.hasTextSearch = false;
    this.props.props.hasDelete = false;
    this.props.props.hasCliftonWorkflow = false;
    this.props.props.hasLyndhurstWorkflow = false;
    this.props.props.hasWayneWorkflow = false;
    this.props.props.hasMedfordWorkflow = false;
    this.props.props.hasSendEmail = false;
    this.props.props.hasRestrictAccessByIP = false;
    this.props.props.hasFoveonicsAdmin = false;
    this.props.props.hasOcrRole = false;
    this.props.props.hasPIIRole = false;
    this.props.props.hasAberdeenWorkflow = false;
    this.props.props.hasGlenrockWorkflow = false;
    this.props.props.hasManageClientsUserRole = false;
    this.props.props.hasAuthenticated = false;
    this.props.props.userHasAuthenticated(false);
  };

  handleClick = async () => {
    //const res = await getGeoLoaction();
    let auditDetails = {
      emailAddress: this.props.props.loggedInUser,
      ipAddress: this.props.props.userIpAddress, //res.IPv4,
      eventLog: "LogOut",
    };

    //saving audit trail details into dynomo db
    saveAuditTrail(auditDetails).then((data) => {});
    this.clearTokens();

    await new Promise((resolve) => {
      try {
        const i = document.createElement("iframe");
        i.style.display = "none";
        i.src =
          "https://login.microsoftonline.com/common/oauth2/v2.0/logout" +
          "?" +
          new URLSearchParams({
            // best-effort hint; Azure ignores if unknown
            logout_hint: this.props.props.loggedInUser || "",
            // after Azure clears its cookie, let it bounce back to our root
            post_logout_redirect_uri: window.location.origin + "/",
          });
        i.onload = () =>
          setTimeout(() => {
            i.remove();
            resolve();
          }, 400);
        document.body.appendChild(i);
        // fail-safe in case onload is blocked by privacy settings
        setTimeout(() => {
          try {
            i.remove();
          } catch {}
          resolve();
        }, 2000);
      } catch {
        resolve();
      }
    });

    this.props.history.push("/");
    await Auth.signOut();
  };

  handleMenuClick = (e) => {
    const { id } = e.target;
    this.props.history.push(`/${id}`);
  };

  render() {
    return (
      <div>
        <div id="header">
          {/* eslint-disable-next-line */}
          <a onClick={this.handleMenuClick}>
            <img
              id="browse"
              src={DocumentSync}
              alt="Browse Repository"
              title="Browse Repository"
            />
          </a>
          <Button
            style={{ marginLeft: "2%" }}
            bsSize="small"
            onClick={this.handleClick}
          >
            Logout
          </Button>
          <Button
            id="helpPage"
            bsSize="small"
            onClick={(e) => {
              e.preventDefault();
              window.open("https://help.documentsync.com", "_blank");
              // window.location.href = "https://help.documentsync.com";
            }}
          >
            Help
          </Button>
          {this.props.props.hasManageMetadataTemplate && (
            <Button
              id="manageindextemplate"
              bsSize="small"
              onClick={this.handleMenuClick}
            >
              Manage Index Template
            </Button>
          )}
          {this.props.props.hasOcrRole && (
            <Button
              id="ocrindextempates"
              bsSize="small"
              onClick={this.handleMenuClick}
            >
              OCR
            </Button>
          )}
          {this.props.props.hasManageRepositories && (
            <div>
              <Button
                id="managerepository"
                bsSize="small"
                onClick={this.handleMenuClick}
              >
                Manage Repository
              </Button>
            </div>
          )}
          {this.props.props.hasManageClientsUserRole && (
            <Button
              id="manageazure"
              bsSize="small"
              onClick={this.handleMenuClick}
            >
              Manage Azure
            </Button>
          )}
          {this.props.props.hasArchiveRole && (
            <Button id="archive" bsSize="small" onClick={this.handleMenuClick}>
              Archive
            </Button>
          )}
          {this.props.props.hasManageUsers && (
            <Button
              id="manageusers"
              bsSize="small"
              onClick={this.handleMenuClick}
            >
              Manage Users
            </Button>
          )}
          <Button id="myaccount" bsSize="small" onClick={this.handleMenuClick}>
            My Account
          </Button>
        </div>
        <div
          style={{
            textAlign: "right",
            width: "98%",
            float: "right",
            marginTop: "-0.1rem",
          }}
        >
          <Button
            bsSize="small"
            style={{
              cursor: "default",
              fontSize: "small",
              color: "grey",
              float: "right",
            }}
          >
            Logged in as: {this.props.props.loggedInUser}
          </Button>
        </div>
      </div>
    );
  }
}

export default Header;
